export enum MedicalTestTypes{
  Routine = 1,
  Incident = 2,
}
